module.exports = __webpack_public_path__ + "img/feedback8-1.5a3134c4.jpg";